import { render, staticRenderFns } from "./personalised-offers.vue?vue&type=template&id=5fe57301&"
import script from "./personalised-offers.vue?vue&type=script&lang=ts&"
export * from "./personalised-offers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "personalised-offers.vue"
export default component.exports